module.exports = __webpack_public_path__ + "static/media/sf_restaurant_16.64dd39e5.jpg";